module.exports = __webpack_public_path__ + "img/logo_01_w.c139f628.svg";